import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MerlinxPassengers} from '../../../shared/interfaces/merlinx-passengers';
import {MerlinxHotelEntry} from '../../../shared/interfaces/merlinx-hotel-entry';
import {Observable, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {MerlinxService} from '../../../shared/services/merlinx.service';
import {EngineMerlinxPassengersModalComponent} from '../engine-merlinx-passengers-modal/engine-merlinx-passengers-modal.component';
import * as dayjs from 'dayjs';
import {MerlinxLandingTypes} from '../../../merlinx/models/merlinx-landing-types.enum';
import {Params, Router} from '@angular/router';

@Component({
  selector: 'app-engine-merlinx-hotels',
  templateUrl: './engine-merlinx-hotels.component.html',
  styleUrls: ['./engine-merlinx-hotels.component.scss']
})
export class EngineMerlinxHotelsComponent implements OnInit {

  constructor(private mxs: MerlinxService,
              private router: Router,
              private modalService: NgbModal) { }

  selectedHotel: MerlinxHotelEntry;
  selectedCheckinDate: NgbDateStruct;
  selectedCheckoutDate: NgbDateStruct;
  selectedRooms: number;
  passengers: MerlinxPassengers = {
    adultsNum: 1,
    childrenNum: 0,
    childrenAges: []
  };

  passengers2: MerlinxPassengers = {
    adultsNum: 1,
    childrenNum: 0,
    childrenAges: []
  };

  isLoading: boolean;

  hotels$: Observable<MerlinxHotelEntry[]>;
  rooms = [1, 2];
  hotelQuery$ = new Subject<string>();

  ngOnInit(): void {
    this.selectedRooms = 1;
    this.hotels$ = this.hotelQuery$.pipe(
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      debounceTime(200),
      switchMap(e => this.mxs.hotelQuery(e)),
      tap(() => this.isLoading = false)
    );
  }

  getHotelItemName(input: MerlinxHotelEntry): string {
    return `${input.n} - ${input.c}`;
  }

  convertDateFromNgb(input: NgbDateStruct): string {
    return dayjs(`${input.day}-${input.month}-${input.year}`, 'D-M-YYYY').format('DD.MM.YYYY');
  }

  convertDateFromDate(input: Date): string {
    return dayjs(input).format('YYYYMMDD');
  }

  canSearch(): boolean {
    const conditions = [];
    conditions.push(!!this.selectedHotel);
    conditions.push(!!this.selectedCheckinDate);
    conditions.push(!!this.selectedCheckoutDate);
    return !conditions.includes(false);
  }

  doSearch(): void {
    const accomodationCode = this.selectedHotel.v;
    const checkin = this.convertDateFromNgb(this.selectedCheckinDate);
    const checkout = this.convertDateFromNgb(this.selectedCheckoutDate);

    const numRooms = this.selectedRooms;
    const agesChilds1 = this.passengers.childrenAges.map(e => this.convertDateFromDate(e)); // First room childs
    const agesChilds2 = this.passengers2.childrenAges.map(e => this.convertDateFromDate(e)); // Second room childs

    const queryParams: Params = {};

    const url = `m/${MerlinxLandingTypes.HOTEL}`;
    queryParams.transport = 'multi';

    queryParams.dynhtllocation = accomodationCode;
    queryParams.trp_startDate = checkin;
    queryParams.trp_endDate = checkout;
    queryParams.doubleroom = numRooms;
    queryParams.ad = this.passengers.adultsNum;
    queryParams.ch = this.passengers.childrenNum;
    agesChilds1.forEach((e, k) => {
      queryParams['cha[' + k + ']'] = e;
    });
    if (numRooms > 1) {
      queryParams['ad-2'] = this.passengers2.adultsNum;
      queryParams['ch-2'] = this.passengers2.childrenNum;
      agesChilds2.forEach((e, k) => {
        queryParams['cha[' + k + '-2]'] = e;
      });
    }

    this.router.navigate([url], {queryParams});
  }

  getPassengerString(input: MerlinxPassengers): string {
    let retString = '';
    if (input.adultsNum > 1 || input.adultsNum === 0) {
      retString += `${input.adultsNum} Adulti`;
    } else {
      retString += `${input.adultsNum} Adulto`;
    }
    if (input.childrenNum === 1) {
      retString += `, ${input.childrenNum} Bambino`;
    }
    if (input.childrenNum > 1) {
      retString += `, ${input.childrenNum} Bambini`;
    }
    return retString;
  }


  openPassengersModal(input: MerlinxPassengers): void {
    const passengersModalRef = this.modalService.open(EngineMerlinxPassengersModalComponent);
    passengersModalRef.componentInstance.passengers = input;
    passengersModalRef.result.then((x: MerlinxPassengers) => {
      input = x;
    }).catch(error => {
      // do nothing
    });
  }

}
